export default __webpack_public_path__ + "static/media/moneyBoyFooterAF.738ca8ce.png";